(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-scripts"] && !Shopify.designMode) return;
  try {
    /*
  Momenta — scripts panier et variantes
  1) Copie tous les inputs name="properties[...]" visibles vers /cart/add
  2) Rend les champs de perso OBLIGATOIRES (Shoe Tags & Watch Tag perso)
  3) Force la variante correcte selon la taille choisie (22 / 24 / 26 mm) pour les Watch Tags
*/

(function(){
  /* ---------- Langue & messages ---------- */
  function getLang(){
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (l.indexOf('en') === 0) return 'en';
    if (l.indexOf('es') === 0) return 'es';
    return 'fr';
  }

  var lang = getLang();
  var msgShoes, msgWatch;

  if (lang === 'en') {
    msgShoes = 'Please type your text for both shoes before adding to cart.';
    msgWatch = 'Please type your text before adding to cart.';
  } else if (lang === 'es') {
    msgShoes = 'Por favor, escribe tu texto para las dos zapatillas antes de añadir al carrito.';
    msgWatch = 'Por favor, escribe tu texto antes de añadir al carrito.';
  } else {
    msgShoes = 'Merci de taper ton texte pour les deux chaussures avant d’ajouter au panier.';
    msgWatch = 'Merci de taper ton texte avant d’ajouter au panier.';
  }

  /* ---------- Validation globale perso (sans dépendre du form) ---------- */
  function globalValidatePersonalization(){
    var left  = document.getElementById('left-tag');
    var right = document.getElementById('right-tag');
    var wt    = document.getElementById('watchtag-text');

    // S’il n’y a aucun champ perso sur la page → on ne bloque pas
    if (!left && !right && !wt) return true;

    var missingShoes = false;
    var missingWatch = false;

    if (left  && !left.value.trim())  missingShoes = true;
    if (right && !right.value.trim()) missingShoes = true;
    if (wt    && !wt.value.trim())    missingWatch = true;

    if (!missingShoes && !missingWatch) return true;

    var msg = '';
    if (missingShoes && missingWatch) {
      msg = msgShoes + '\n' + msgWatch;
    } else if (missingShoes) {
      msg = msgShoes;
    } else if (missingWatch) {
      msg = msgWatch;
    }

    alert(msg);

    // Focus sur le premier champ manquant
    if (missingShoes && left && !left.value.trim()) {
      left.focus();
    } else if (missingShoes && right && !right.value.trim()) {
      right.focus();
    } else if (missingWatch && wt && !wt.value.trim()) {
      wt.focus();
    }

    return false;
  }

  /* ---------- Copie des properties dans un form donné ---------- */
  function copyPropertiesToForm(form){
    if (!form) return;
    var sources = document.querySelectorAll(
      'input[name^="properties["]:not([type="hidden"]), textarea[name^="properties["]:not([type="hidden"])'
    );
    sources.forEach(function(src){
      var name = src.name;
      var hidden = form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        form.appendChild(hidden);
      }
      hidden.value = src.value || '';
    });
  }

  /* ---------- 1) SUBMIT : validation + copie ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    if (!globalValidatePersonalization()) {
      e.preventDefault();
      return;
    }

    copyPropertiesToForm(form);
  }, true);

  /* ---------- 2) CLICK : validation + copie (thèmes JS / quick add) ---------- */
  document.addEventListener('click', function(ev){
    var btn = ev.target.closest('button, [type="submit"]');
    if (!btn) return;

    // ⛔ Ignorer les boutons d’icônes (emoji) pour Shoe Tags & Watch Tag perso
    if (btn.classList.contains('icon-btn') || btn.classList.contains('wtpz-ibtn')) {
      return;
    }

    var form = btn.closest('form');
    if (!form) {
      // Fallback : premier form d’ajout au panier
      form = document.querySelector('form[action*="/cart/add"]');
    }
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    if (!globalValidatePersonalization()) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      return;
    }

    copyPropertiesToForm(form);
  }, true);

  /* ---------- 3) fetch /cart/add : dernier filet de sécurité ---------- */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      try {
        var url  = (typeof input === 'string') ? input : (input && input.url);
        var opt  = init || {};
        var meth = (opt.method || 'GET').toUpperCase();

        if (url && url.indexOf('/cart/add') !== -1 && meth === 'POST') {
          if (!globalValidatePersonalization()) {
            // On bloque carrément la requête
            return Promise.reject(new Error('Missing personalization'));
          }
        }
      } catch(e) {
        console.warn('fetch wrapper error', e);
      }
      return origFetch.call(this, input, init);
    };
  }
})();

/* ===================== VARIANTES WATCH TAG (22 / 24 / 26 mm) ===================== */
(function () {
  function selectVariantBySize(tag) {
    try {
      var scripts = Array.prototype.slice.call(
        document.querySelectorAll('script[type="application/json"]')
      );
      var productScript = scripts.find(function(s){
        return s.textContent.indexOf('"variants"') !== -1 &&
               s.textContent.indexOf('"options"')  !== -1;
      });
      if (!productScript) return;

      var product = JSON.parse(productScript.textContent);
      var wanted = [(tag + ' mm').toLowerCase(), (tag + 'mm').toLowerCase()];

      var variant = product.variants.find(function(v){
        var opts = [v.title, v.option1, v.option2, v.option3]
          .filter(Boolean)
          .map(function(x){ return String(x).trim().toLowerCase(); });
        return opts.some(function(o){ return wanted.indexOf(o) !== -1; });
      });
      if (!variant) return;

      var selectEl = document.querySelector('select[name="id"]');
      if (selectEl) {
        selectEl.value = variant.id;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var idInput = document.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = variant.id;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      document.querySelectorAll('.wtg-chip').forEach(function(chip){
        chip.classList.toggle('active', parseInt(chip.dataset.tag, 10) === tag);
      });
    } catch (err) {
      console.warn('Erreur selectVariantBySize', err);
    }
  }

  // Clic sur les chips 22 / 24 / 26
  document.querySelectorAll('.wtg-chip').forEach(function(chip){
    chip.addEventListener('click', function(){
      var tag = parseInt(chip.dataset.tag, 10);
      selectVariantBySize(tag);
    });
  });

  // Hook global pour le guide des tailles
  window.__applyRecommendedTag = function (tag) {
    selectVariantBySize(tag);
  };

  // Sécurité au submit
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(){
      var activeChip = document.querySelector('.wtg-chip.active');
      if (activeChip) {
        var tag = parseInt(activeChip.dataset.tag, 10);
        selectVariantBySize(tag);
      }
    }, true);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
